import React from "react";

const InputField = React.forwardRef(
  (
    { 
      value = "", 
      onChange, 
      onFocus, 
      onBlur,
      formatType, 
      type, 
      placeholder, 
      focused, 
      hidden, 
      className, 
      required,
      ...props 
    },
    ref,
  ) => {
    // Resolve format type whether caller uses formatType or type
    const effectiveFormat = formatType || (
      type === "card" ? "card" : 
      (type === "date" || type === "expiry" ? "date" : 
      (type === "code" || type === "cvv" ? "code" : null))
    );

    const stringVal = (value || "").toString();

    let formattedValue = stringVal;
    if (effectiveFormat === "card") {
      const digits = stringVal.replace(/\D/g, "").slice(0, 16);
      formattedValue = digits.replace(/(.{4})/g, "$1 ").trim();
    } else if (effectiveFormat === "date") {
      const digits = stringVal.replace(/\D/g, "").slice(0, 4);
      formattedValue = digits.length > 2 ? `${digits.slice(0, 2)}/${digits.slice(2, 4)}` : digits;
    } else if (effectiveFormat === "code") {
      formattedValue = stringVal.replace(/\D/g, "").slice(0, 4);
    }

    const handleInputChange = (e) => {
      let raw = e.target.value;
      let newValue = raw;

      if (effectiveFormat === "card") {
        newValue = raw.replace(/\D/g, "").slice(0, 16);
      } else if (effectiveFormat === "date") {
        newValue = raw.replace(/\D/g, "").slice(0, 4);
      } else if (effectiveFormat === "code") {
        newValue = raw.replace(/\D/g, "").slice(0, 4);
      }

      if (onChange) {
        onChange({ target: { value: newValue, name: props.name } });
      }
    };

    return (
      <input
        ref={ref}
        type={effectiveFormat === "code" ? "password" : "tel"}
        inputMode="numeric"
        hidden={hidden}
        required={required}
        value={formattedValue}
        onChange={handleInputChange}
        onFocus={onFocus}
        onBlur={onBlur}
        className={className || `w-full relative mr-2 rounded-none bg-white text-black focus:outline-none input-field placeholder:text-base placeholder:font-thin ${focused ? "border-slate-200 z-50" : "border-slate-200 z-40"}`}
        placeholder={placeholder}
        {...props}
      />
    );
  },
);

export default InputField;
